import { FC } from 'react';
import { ProButton } from '../antd';
import { BaseOperationButtonProps } from './interface';
import { ICON_COLLECTION } from '../constants/icon';

/** 通过按钮 */
const AdoptButton: FC<BaseOperationButtonProps> = props => {
  const { children, text, icon, ...restProps } = props;
  return (
    <ProButton icon={icon} {...restProps}>
      {children || text}
    </ProButton>
  );
};

AdoptButton.defaultProps = {
  icon: ICON_COLLECTION.ADOPT,
  text: '通过',
};

export default AdoptButton;
